<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
    <li class="dropdown" :class="{ open: open }">
        <a href="javascript://" v-click-out="hide" @click="toggle">
            <i class="fa fa-fw fa-plus visible-xs-inline-block"></i>
            <span>Novo</span>
            <span class="caret"></span>
        </a>
        <ul class="dropdown-menu" role="menu">
            <li><router-link :to="{name: 'comitente.novo'}">Comitente</router-link></li>
            <li><router-link :to="{name: 'leiloes.novo'}"><span>Leilão</span> </router-link></li>
            <li><router-link :to="{name: 'usuario.novo'}">Usuário Intranet</router-link></li>
            <li class="divider"></li>
            <li><router-link :to="{name: 'banners.novo'}"><span>Banner</span> </router-link></li>
            <li><router-link :to="{name: 'popup.novo'}"><span>Pop-up</span> </router-link></li>
        </ul>
    </li>
</template>



// WEBPACK FOOTER //
// DDNew.vue?9f7cdf14